import { ShareLink } from './shareLink'
import { Share } from './share'
import Style from './templateShare.module.scss'
import { getTemplateShareText } from '~/api'
import IconPark from '~/components/iconPark/index.vue'

export const TemplateShare = defineComponent({
  props: {
    isCard: {
      type: Boolean,
      default: false,
    },
    linkUrl: {
      type: String,
      default: '',
    },
    hasShare: {
      type: Boolean,
      default: true,
    },
    trackParams: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    showExtra: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shareToOuterUser: {
      type: Boolean,
      default: true,
    },
    shareToInnerUser: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      require: false,
    },
    eventName: {
      type: String,
      require: false,
    },
    disabledText: {
      type: String,
      require: false,
    },
  },
  setup(props, { expose }) {
    const { $t } = useNuxtApp()
    const shareVisible = useShare()
    const slots = useSlots()
    const loading = ref(false)

    const params = {
      ...props.params,
    }
    let shareText: string = ''
    const show = ref(false)
    const onOpenChange = async (visible: boolean) => {
      if (props.disabled) {
        return
      }
      show.value = visible
      shareVisible.value = visible

      if (props.templateId && visible) {
        loading.value = true
        const res = await getTemplateShareText({
          template_id: props.templateId,
        })
        if (res?.data?.length) {
          shareText = `${res.data?.[0] || ''}${props.linkUrl} ${
            res.data?.[1] || ''
          }`
        }
        loading.value = false
      }
    }

    watch(
      () => shareVisible.value,
      (cur, before) => {
        if (cur !== before && !cur) {
          show.value = false
        }
      }
    )

    const eventName = props.eventName || TRACK_EVENT.YOUYAN_PLATFORM_SHARE

    return () => (
      <a-popover
        trigger="click"
        open={show.value}
        placement="topRight"
        onOpenChange={onOpenChange}
      >
        {{
          content: () => [
            <div
              class="text-16 pb-[10px] mb-[12px] text-center -mx-[12px] font-semibold text-font-1"
              style="border-bottom: 1px solid var(--back-4);"
            >
              {props.title || $t('fen-xiang-kong-ge') + $t('mo-ban')}
            </div>,
            <div class="w-[360px] p-[18px] pt-[0px] pb-[12px]">
              {checkPermission(ActionListKey.TEMPLATE_SHARE) &&
                props.shareToInnerUser && (
                  <Share
                    params={params}
                    eventName={eventName}
                    height="170px"
                    trackParams={props.trackParams}
                    showExtra={props.showExtra}
                    linkUrl={props.linkUrl}
                  />
                )}
              {props.linkUrl && props.shareToOuterUser && (
                <ShareLink
                  key={shareText}
                  url={props.linkUrl}
                  text={shareText}
                  eventName={eventName}
                  disabled={loading.value}
                  trackParams={props.trackParams}
                  onClose={
                    !checkPermission(ActionListKey.TEMPLATE_SHARE)
                      ? onOpenChange
                      : () => {}
                  }
                  name={`${
                    checkPermission(ActionListKey.TEMPLATE_SHARE) &&
                    props.shareToInnerUser
                      ? '2.'
                      : ''
                  }${$t('fen-xiang-gei-wai-bu-yong-hu')}`}
                />
              )}
            </div>,
          ],
          default: () =>
            !props?.isCard ? (
              <div
                class={[
                  'w-[32px] h-[32px] outline-0 flex-y-center justify-center rounded-[50%]',
                  `${
                    props.disabled
                      ? '!cursor-not-allowed opacity-60'
                      : 'cursor-pointer'
                  }`,
                  Style.shareModalIcon,
                ]}
              >
                <a-popover
                  content={
                    <span class="text-font-1">
                      {props.disabled
                        ? $t('shang-jia-hou-ji-ke-cao-zuo')
                        : $t('fen-xiang')}
                    </span>
                  }
                >
                  {slots.default ? (
                    slots.default()
                  ) : (
                    <div class="h-[28px] w-[28px] rounded-full text-white flex-y-center bg-[rgba(0,0,0,0.4)] text-center hover:bg-[rgba(0,0,0,0.6)] justify-center">
                      <IconPark
                        name="arrow-share"
                        size="14"
                        class={`${props.iconClass}`}
                      />
                    </div>
                  )}
                </a-popover>
              </div>
            ) : (
              <div class={Style.shareIcon}>
                <a-popover
                  content={
                    props.disabled ? props.disabledText : $t('fen-xiang')
                  }
                >
                  {slots.default ? (
                    slots.default()
                  ) : (
                    <div class="h-[28px] w-[28px] rounded-full text-white flex-y-center bg-[rgba(0,0,0,0.4)] text-center hover:bg-[rgba(0,0,0,0.6)] justify-center">
                      <IconPark
                        name="arrow-share"
                        size="14"
                        class={`${props.iconClass}`}
                      />
                    </div>
                  )}
                </a-popover>
              </div>
            ),
        }}
      </a-popover>
    )
  },
})
